<template>
    <div class="col-12 p-3">
        <div class="row d-block">
            <div class="col-12 col-md-3">
                <div class="my-3">
                    <SearchComponent v-model="filters.search"/>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center mb-3">
            <div class="d-flex flex-column flex-md-row input-group-sm my-md-3 w-100 w-md-auto">
                <datetime
                    class="my-1 mr-md-2"
                    v-model="filters.fecha_compra_desde"
                    @input="debouncedGetEntradas()"
                    placeholder="Fecha desde"
                    input-class="custom-select h-100"
                    type="datetime"
                />
                <datetime
                    class="my-1 mr-md-2"
                    v-model="filters.fecha_compra_hasta"
                    @input="debouncedGetEntradas()"
                    placeholder="Fecha hasta"
                    input-class="custom-select h-100"
                    type="datetime"
                />
                
                <select class="custom-select w-auto my-1 mr-md-2" id="search" v-model="filters.search_for" @change="debouncedGetEntradas()">
                    <option value="">Buscar por</option>
                    <option value="n_pedido">Nº de pedido</option>
                    <option value="qr_code">Código QR</option>
                    <option value="name">Nombre y apellidos</option>
                    <option value="telefono">Teléfono</option>
                    <option value="email">Email</option>
                    <option value="importe">Importe</option>
                    <option value="email_taquillero">Taquillero/a</option> 
                    <option value="concepto">Concepto</option>
                    <option value="n_abonado">Nº Abonado</option>
                </select>

                <select class="custom-select w-auto my-1 mr-md-2" v-model="filters.estado" @change="debouncedGetEntradas()">
                    <option value="">Estado</option>
                    <option value="enviado">ENVIADO</option>
                    <option value="no_enviado">NO ENVIADO</option>
                </select>

                <select class="custom-select w-auto my-1 mr-md-2" v-model="filters.modalidad" @change="debouncedGetEntradas()">
                    <option value="">Modalidad</option>
                    <option value="0">ONLINE</option>
                    <option value="1">TAQUILLA</option>
                </select>
                <div class="d-flex align-items-center mt-1 mt-md-0">
                    <div class="d-flex flex-column flex-md-row w-100 w-md-auto">
                        <Button @click="clearFilters" class="mr-md-2 mr-0 mb-2 mb-md-0" style="padding: 10px;" icon="fa fa-trash" name="tooltip" v-b-tooltip.hover.bottom title="Limpiar filtros" />
                        <router-link :to="{ name: 'back.events.invitaciones', params: { evento_id, sesion_id }}" class="btn btn-secondary mr-0 mr-md-2 mb-2 mb-md-0">INVITACIONES</router-link>
                        <router-link :to="{ name: 'back.events.imprimir-pegatinas', params: { evento_id, sesion_id }}" class="btn btn-secondary">IMPRIMIR BUTACAS</router-link>
                    </div>
                </div>
            </div>
            
        </div>
        

        <span>
            <div class="row d-none d-md-flex font-weight-bold">
                <label class="h5 col-2 mr-4">GENERADO</label>
                <label class="h5 col-2 mr-4">MODALIDAD</label>
                <label class="h5 col-2">TAQUILLERO / EMAIL ENVÍO</label>
                <label class="h5 col-2">Nº ABONADO</label>
                <label class="h5 col-2">ENVIADO</label>
            </div>
            <hr class="d-none d-md-block mt-2"/>
            <div v-if="!loading">
                <template v-if="entradas?.data?.length > 0">
                    <div v-for="(entrada, index) in entradas.data" :key="index" class="entrada-item">
                        <div class="row mb-2" :data-cy="'pedido-' + entrada.id">
                            <div class="col-12 col-md-9">
                                <div class="mb-2">
                                    <div class="d-md-none mobile-layout">
                                        <div class="mobile-row">
                                            <div class="mobile-label">GENERADO</div>
                                            <div class="mobile-value">{{ entrada.id }}</div>
                                        </div>
                                        <div class="mobile-row">
                                            <i class="text-success fas fa-calendar-alt m-1"></i>
                                            <span class="mobile-value">{{ entrada.fecha }}</span>
                                        </div>
                                        <div class="mobile-row">
                                            <strong class="mobile-value">
                                                <template v-if="! entrada.anulado">
                                                    {{ entrada.precio | formatear_precio }}
                                                </template>
                                                <template v-else-if="entrada.anulado && !entrada.caducado">
                                                    ANULADO
                                                </template>
                                                <template v-else>
                                                    CADUCADAS
                                                </template>
                                            </strong>
                                        </div>

                                        <div class="mobile-row">
                                            <div class="mobile-label">MODALIDAD</div>
                                        </div>
                                        <div class="mobile-row">
                                            <i class="text-success fas fa-credit-card m-1"></i>
                                            <span class="mobile-value">{{ entrada.metodo_pago | formatear_metodo_pago_entrada }}</span>
                                        </div>
                                        <div class="mobile-row">
                                            <i class="text-success fas fa-ticket-alt m-1"></i>
                                            <span class="mobile-value">{{ entrada.modalidad | formatear_modalidad }}</span>
                                        </div>

                                        <div class="mobile-row">
                                            <div class="mobile-label">TAQUILLERO / EMAIL</div>
                                        </div>
                                        <div class="mobile-row">
                                            <span class="mobile-value text-break">{{ entrada.email_taquillero }}</span>
                                        </div>
                                        <div class="mobile-row">
                                            <span class="mobile-value text-break">{{ entrada.email_comprador || "NO ENVIADAS" }}</span>
                                        </div>

                                        <div class="mobile-row">
                                            <div class="mobile-label">Nº ABONADO</div>
                                            <span class="mobile-value">
                                                <span v-if="entrada.entradas[0] && entrada.entradas[0].abonado">
                                                    {{ entrada.entradas[0].abonado.n_abonado }}
                                                </span>
                                                <span v-else>-</span>
                                            </span>
                                        </div>

                                        <div class="mobile-row">
                                            <div class="mobile-label">ENVIADO</div>
                                        </div>
                                        <div class="mobile-row">
                                            <i :class="entrada.fecha_envio != '' ? 'text-success fas fa-calendar-alt m-1' : 'text-danger fas fa-calendar-alt'"></i>
                                            <span class="mobile-value">
                                                {{ entrada.fecha_envio ? 'Fecha: ' + entrada.fecha_envio : 'NO ENVIADO' }}
                                            </span>
                                        </div>
                                        <div class="mobile-row">
                                            <span class="mobile-value">
                                                <strong>Whatsapp:</strong> {{entrada.envio_whatsapp ? 'SI': 'NO'}}
                                            </span>
                                        </div>

                                        <div class="mobile-row concepto-row">
                                            <span class="mobile-value">
                                                {{ entrada.entradas.length > 0 ? entrada.entradas[0].concept : '' }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="d-none d-md-block">
                                        <div class="row">
                                            <div class="col-7 col-md-3">
                                                <div>
                                                    <span type="entrada_id">
                                                        <strong class="mvl">GENERADO</strong> {{ entrada.id }}
                                                    </span>
                                                </div>
                                                <i class="text-success fas fa-calendar-alt mr-1"></i>{{ entrada.fecha }}
                                                <br/>
                                                <strong>
                                                    <template v-if="! entrada.anulado">
                                                        {{ entrada.precio | formatear_precio }}
                                                    </template>
                                                    <template v-else-if="entrada.anulado && !entrada.caducado">
                                                        ANULADO
                                                    </template>
                                                    <template v-else>
                                                        CADUCADAS
                                                    </template>
                                                </strong>
                                            </div>
                                            <div class="col-5 col-md-2">
                                                <strong class="mvl">MODALIDAD</strong><br/>
                                                <i class="text-success fas fa-credit-card mr-1"></i>{{ entrada.metodo_pago | formatear_metodo_pago_entrada }}
                                                <br/>
                                                <i class="text-success fas fa-ticket-alt mr-1"></i>{{ entrada.modalidad | formatear_modalidad }}
                                            </div>
                                            <div class="col-12 col-md-6 d-flex">
                                                <div class="col-md-7 ml-md-2 mr-md-5 text-center" style="padding-left: 4.5rem;">
                                                    <strong class="mvl">TAQUILLERO / EMAIL ENVÍO</strong><br/>
                                                    {{ entrada.email_taquillero }} <br/>
                                                    {{ entrada.email_comprador || "NO ENVIADAS" }}
                                                </div>
                                                <div class="col-md-2 mr-md-4">
                                                    <strong class="mvl">Nº ABONADO</strong><br/>
                                                    <span v-if="entrada.entradas[0] && entrada.entradas[0].abonado">
                                                        {{ entrada.entradas[0].abonado.n_abonado }}
                                                    </span>
                                                </div>
                                                <div class="col-md-5 text-center d-none d-md-block pl-3">
                                                    <i :class="entrada.fecha_envio != '' ? 'text-success fas fa-calendar-alt' : 'text-danger fas fa-calendar-alt'"></i> 
                                                    {{ entrada.fecha_envio ? 'Fecha de envío: ' + entrada.fecha_envio : 'NO ENVIADO' }}
                                                    <p><strong>Whatsapp enviado:</strong> {{entrada.envio_whatsapp ? 'SI': 'NO'}}</p>            
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6 d-md-none mvl_mrgn">
                                                <strong class="mvl">ENVIADO</strong><br/>
                                                <i :class="entrada.fecha_envio != '' ? 'text-success fas fa-calendar-alt' : 'text-danger fas fa-calendar-alt'"></i> 
                                                {{ entrada.fecha_envio ? 'Fecha de envío: ' + entrada.fecha_envio : 'NO ENVIADO' }}
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <p>{{ entrada.entradas.length > 0 ? entrada.entradas[0].concept : '' }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-3 text-right mobile-buttons">
                                <button id="entradas-count" class="btn btn-primary mr-3 mb-3" @click="expandir2(index)">Entradas ({{ entrada.qr_codes.length}})</button>
                                <div :class="'btn-group dropleft ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                    <button type="button" class="btn btn-primary dropdown-toggle mb-3" @click.prevent="expandir(index)">OPCIONES</button>
                                    <div :class="'dropdown-menu ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                        <template v-if="!entrada.anulado">
                                            <a
                                                target="_blank"
                                                class="dropdown-item"
                                                :href="api_base + '/eventos/' + evento_id + '/estado/' + sesion_id + '/pedido/' + entrada.id + '/imprimir-recibo?tid=' + configuracion.hash_teatro + '&api_key=' + api_key"
                                            >
                                                Imprimir recibo de compra
                                            </a>
                                            <a
                                                class="dropdown-item"
                                                :href="imprimir_url | formatear_url({ '%EVENTO_ID%' : evento_id, '%SESION_ID%' : sesion_id, 'qr_codes' : [entrada.qr_codes], 'tid': configuracion.hash_teatro })" 
                                                target="_blank"
                                            >
                                                Imprimir entradas
                                            </a>
                                            <a 
                                                class="dropdown-item" 
                                                :href="api_base + '/f/partidos/entradas/pdf?qr_codes=' + [entrada.qr_codes] + '&event_id=' + $route.params.evento_id + '&tid=' + configuracion.hash_teatro"
                                                target="_blank"
                                            >
                                                Descargar entradas
                                            </a>
                                            <a 
                                                v-if="entrada.modalidad == 1 && entrada.metodo_pago == 1 || entrada.metodo_pago == 3 || entrada.metodo_pago == 8" 
                                                class="dropdown-item" 
                                                href="#" 
                                                @click.prevent="showModal('editarMetodoPago-' + entrada.id)"
                                            >
                                                Editar método de pago
                                            </a>
                                            <EditarMetodoPagoPedidoModal
                                                :pedido="entrada"
                                                :sesion_id="sesion_id"
                                                :evento_id="evento_id"
                                                v-on:close="closeModal"
                                                v-on:updated="getEntradas"
                                            />
                                            <a class="dropdown-item" href="#" @click.prevent="showModal('email-' + entrada.id)">Enviar por email</a>
                                            <SendEmailModal
                                                :email="entrada.email_comprador"
                                                :entradas="entrada.entradas"
                                                :id="entrada.id"
                                                :user_order="entrada.id"
                                                :sesion_id="sesion_id"
                                                :evento_id="evento_id"
                                                v-on:close="closeModal"
                                                v-on:updated="getEntradas"
                                            />
                                            <a class="dropdown-item" href="#" @click.prevent="showModal('whatsapp-' + entrada.id)">Enviar por WhatsApp</a>
                                            <SendWhatsAppModal
                                                :pedido="entrada"
                                                :id="entrada.id"
                                                :user_order="entrada.id"
                                                :sesion_id="sesion_id"
                                                :evento_id="evento_id"
                                                v-on:close="closeModal"
                                                v-on:updated="getEntradas"
                                            />
                                            <template v-if="puedeAnularse(entrada)">
                                                <a 
                                                    class="dropdown-item" 
                                                    href="#" 
                                                    @click.prevent="showModal('anular-pedido-' + entrada.id)"
                                                >
                                                    Anular
                                                </a>
                                                <AnularPedidoModal
                                                    :pedido="entrada"
                                                    :id="entrada.id"
                                                    :sesion_id="sesion_id"
                                                    :evento_id="evento_id"
                                                    :evento_pasado="evento.pasado"
                                                    v-on:close="closeModal"
                                                    v-on:anulada="getEntradas"
                                                />
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-if="entrada.datafono_devolucion_response">
                                                <a 
                                                    target="_blank"
                                                    :href="api_base + '/eventos/' + evento_id + '/estado/' + sesion_id + '/pedido/' + entrada.id + '/recibo-devolucion?tid=' + configuracion.hash_teatro + '&api_key=' + api_key"
                                                    class="dropdown-item"
                                                >
                                                    Imprimir recibo devolución
                                                </a>
                                            </template>
                                            <template v-else>
                                                <div class="dropdown-item"><b>ANULADO</b></div>
                                            </template>
                                        </template>                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :key="'2-' + index" v-if="expand2.indexOf(index) >= 0" :class="expand.indexOf(index) >= 0 ? 'bg-light' : ''">
                            <div class="row">
                                <div class="col-2">
                                    <p><strong>Privacidad:</strong> {{entrada.privacidad ? 'SI': 'NO'}}</p>
                                </div>
                                <div class="col-2">
                                    <p><strong>Condiciones:</strong> {{entrada.condiciones ? 'SI': 'NO'}}</p>
                                </div>
                                <div class="col-2">
                                    <p><strong>Comunicaciones:</strong> {{entrada.comunicaciones ? 'SI': 'NO'}}</p>
                                </div>
                            </div>
                            <div  v-for="(ticket, index) in entrada.entradas" :key="'ticket-' + index" class="row" :data-cy="'entrada-' + ticket.qr_code">
                                <div class="col-12 col-md-6">
                                    <div class="row">
                                        <div class="col-4">
                                            <p>
                                                <strong>{{ calcularPrecio(ticket) | formatear_precio }}</strong><br/>
                                                {{ ticket.concepto }}<br/>
                                                {{ ticket.nombre }}
                                            </p>
                                        </div>
                                        <div class="col-4">
                                            <p>
                                                <strong>{{ ticket.qr_code }}</strong><br/>
                                                <template v-if="ticket.zona_plaza">
                                                    {{ ticket.zona_plaza }} <br/>
                                                </template>
                                                <template v-else-if="ticket.zona">
                                                    {{ ticket.zona }} <br/>
                                                </template>
                                                <span v-if="ticket.zona_plaza || ticket.butaca_plaza">{{ formatTicketInfo(ticket) }}</span>
                                                <span v-if="ticket.fila">Fila: {{ ticket.fila }} / Butaca: {{ ticket.seat }}</span>
                                            </p>
                                        </div>
                                        <div class="col-4" v-if="ticket.email_taquillero_devolucion">
                                            <span>Anulado por: {{ ticket.email_taquillero_devolucion }}</span>
                                        </div>
                                        <div class="col-4 text-center" v-if="ticket.tiene_regalo">
                                            <p><strong>Regalo recogido:</strong></p>
                                            <span v-if="ticket.regalo_recogido">
                                                {{ ticket.regalo_recogido }}
                                            </span>
                                            <span v-else>
                                                No
                                            </span>
                                        </div>
                                        <div class="col-4" v-if="ticket.fecha_caducidad">
                                            <p>Caducada: <strong>{{ ticket.fecha_caducidad }}</strong></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 text-right">
                                    <template v-if="ticket.deleted_at == null">
                                        <b-button 
                                            class="mr-3 mb-3" 
                                            v-if="ticket.tiene_regalo && ! ticket.regalo_recogido"
                                            @click="entregarRegalo(ticket.id)"
                                        >
                                            Entregar regalo
                                        </b-button>
                                        <a class="btn btn-primary mr-3 mb-3" href="#" @click.prevent="showModal('editarNombre-' + ticket.id)">Editar</a>
                                        <EditarEntradaModal
                                            :ticket="ticket"
                                            :sesion_id="sesion_id"
                                            :evento_id="evento_id"
                                            v-on:close="closeModal"
                                        />
                                        <a class="btn btn-primary mr-3 mb-3 btn_rgt" href="#" @click.prevent="showModal('email-' + ticket.id)">Enviar por email</a>
                                        <SendEmailModal
                                            :email="entrada.email_comprador"
                                            :entradas="[ticket]"
                                            :id="ticket.id"
                                            :user_order="entrada.id"
                                            :sesion_id="sesion_id"
                                            :evento_id="evento_id"
                                            v-on:close="closeModal"
                                            v-on:updated="getEntradas"
                                        />
                                        <a class="btn btn-primary mr-3 mb-3" href="#" @click.prevent="showModal('whatsapp-' + ticket.id)">Enviar por WhatsApp</a>
                                        <SendWhatsAppModal
                                            :entradas="[ticket]"
                                            :id="ticket.id"
                                            :user_order="entrada.id"
                                            :sesion_id="sesion_id"
                                            :evento_id="evento_id"
                                            v-on:close="closeModal"
                                            v-on:updated="getEntradas"
                                        />
                                        <template v-if="!entrada.anulado && puedeAnularse(entrada)">
                                            <a class="btn btn-primary mb-3" href="#" @click.prevent="showModal('anular-' + ticket.id)">Anular</a>
                                            <AnularModal
                                                :pedido="entrada"
                                                :entrada="ticket"
                                                :metodo_pago="entrada.metodo_pago"
                                                :id="ticket.id"
                                                :sesion_id="sesion_id"
                                                :evento_id="evento_id"
                                                :evento_pasado="evento.pasado"
                                                v-on:close="closeModal"
                                                v-on:anulada="getEntradas"
                                            />
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="ticket.datafono_devolucion_response">
                                            <a
                                                class="btn btn-primary"
                                                target="_blank"
                                                :href="api_base + '/eventos/' + evento_id + '/estado/' + sesion_id + '/pedido/' + entrada.id + '/entradas/' + ticket.id + '/recibo-devolucion?tid=' + configuracion.hash_teatro + '&api_key=' + api_key"
                                            >
                                                Imprimir recibo devolución
                                            </a>
                                        </template>
                                        <template v-else>
                                            <div class="dropdown-item"><b>ANULADO</b></div>
                                        </template>
                                    </template>
                                </div>
                                <hr v-if="index < entrada.entradas.length - 1" style="width: 99%;"/>
                            </div>
                        </div>
                        <hr v-if="entradas?.data?.length > 0"/>
                    </div>
                </template>
                <div v-else>
                    <h5 class="p-3">No se han vendido entradas en este evento</h5>
                </div>
            </div>
            <div 
                v-else
                class="col-12"
                style="margin-top: 20px; height: 100px;" 
            >
                <LoaderComponent />
            </div>
        </span>
        <div class="row justify-content-between">
            <div class="col-12 col-md-3">
                <ElementosPorPaginaComponent v-model="filters.per_page"/>
            </div>
            <div class="col-12 col-md-4">
                <PaginateComponent :current_page="loading ? 1 : entradas.meta.current_page" :last_page="loading ? 1 : entradas.meta.last_page" @change_page="setPage"/>
            </div>
        </div>
    </div>
</template>

<script>
    import SendEmailModal from '@/views/backend/events/modals/SendEmailModal';
    import SendWhatsAppModal from '@/views/backend/events/modals/SendWhatsAppModal';
    import AnularModal from '@/views/backend/events/modals/AnularModal';
    import AnularPedidoModal from '@/views/backend/events/modals/AnularPedidoModal';
    import EditarEntradaModal from "@/views/backend/events/modals/EditarEntradaModal";
    import EditarMetodoPagoPedidoModal from "@/views/backend/events/modals/EditarMetodoPagoPedidoModal";
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';

    export default {
        props: ['sesion_id', 'evento', 'evento_id', 'sesiones'],
        data(){
            return{
                entradas: null,
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    search_for: "",
                    modalidad: "", 
                    estado: "",
                    fecha_compra_hasta: "",
                    fecha_compra_desde: "",
                },
                expand: [],
                expand2: [],
                qr_codes: null,
                api_base: process.env.VUE_APP_API_BASE,
                n_pedido: null 
            }
        },
        created() {
            this.imprimir_url = this.config.IMPRIMIR_URL;
            this.debouncedGetEntradas = _.debounce(this.getEntradas, 500);
            if(this.$route.query.n_pedido){
                this.filters.search = this.$route.query.n_pedido
                this.filters.search_for = "n_pedido"
            }
        },
        watch: {
            "filters.search"() {
                this.debouncedGetEntradas();
            },
            "filters.fecha_compra"() {
                this.debouncedGetEntradas();
            },
            "filters.per_page"() {
                this.filters.page = 1; this.debouncedGetEntradas();
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            api_key() {
                return localStorage.getItem('token');
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            esAyuntamientoMurcia() {
                if (this.evento.teatro_company) {
                    return this.evento.teatro_company.nif === 'P3003000A';
                }

                return false
            }
        },
        methods: {
            puedeAnularse(pedido) {
                const { metodo_pago, entradas } = pedido;

                if (this.esAyuntamientoMurcia && pedido.modalidad == 1 && metodo_pago == 3) {
                    return false;
                }
                
                if (metodo_pago === 1 && !this.permisos['eventos.devoluciones.metalico']) {
                    return false;
                }

                if ([6, 10].includes(metodo_pago)) {
                    const entradasAccedidas = entradas.some(entrada => entrada.hora_entrada);

                    if (entradasAccedidas) {
                        if (!this.permisos['eventos.anular.invitaciones.accedidas']) {
                            return false;
                        }
                    } else {
                        if (!this.permisos['eventos.anular.invitaciones']) {
                            return false;
                        }
                    }
                }

                return true;
            },
            calcularPrecio(entrada) {
                var precio = parseFloat(entrada.precio);

                if(!entrada.price_management_interno) {
                    precio = precio + parseFloat(entrada.price_management);
                }

                return precio;
            },
            getEntradas : function() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.entradas.index'), this.searchParams()).then(res => {
                    this.entradas = res.data;
                    this.loading = false;
                }).catch(() => {
                    console.error('Error al obtener el listado de entradas');
                });
            },
            entregarRegalo(entrada_id) {
                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    entrada_id: entrada_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.entradas.recoger.regalo'), params).then(res => {
                    this.getEntradas();
                });
            },
            setPage(page) {
                this.filters.page = page;
                this.getEntradas();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand = [index];
                }
            },
            expandir2(index) {
                if(this.expand2.indexOf(index) >= 0) {
                    this.expand2.splice(this.expand2.indexOf(index), 1);
                } else {
                    this.expand2 = [index];
                }
            },
            searchParams() {
                const params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    filters : {
                        per_page: this.filters.per_page,
                        page: this.filters.page,
                        modalidad: this.filters.modalidad,
                        estado: this.filters.estado,
                        fecha_compra_hasta: this.filters.fecha_compra_hasta,
                        fecha_compra_desde: this.filters.fecha_compra_desde
                    }
                };
    
                if(this.filters.search_for !== "") {
                    params.filters[this.filters.search_for] = this.filters.search;
                }

                return params;
            },
            clearFilters() {
                this.filters.search = '';
                this.filters.search_for = '';
                this.filters.modalidad = '',
                this.filters.estado = '';
                this.filters.fecha_compra = '';

                this.getEntradas();
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            formatTicketInfo(ticket) {
                if (ticket.sector_plaza) {
                    return `Sector: ${ticket.sector_plaza} / Fila: ${ticket.fila_plaza} / Butaca: ${ticket.butaca_plaza}`;
                } else if (ticket.fila_plaza && ticket.butaca_plaza) {
                    return `Fila: ${ticket.fila_plaza} / Butaca: ${ticket.butaca_plaza}`;
                } else {
                    return `Nombre: ${ticket.nombre_plaza} / Num: ${ticket.num_plaza}`;
                }
            }
        },
        components: {
            SendEmailModal, SendWhatsAppModal, AnularModal, AnularPedidoModal,
            EditarEntradaModal, EditarMetodoPagoPedidoModal, ElementosPorPaginaComponent, SearchComponent, PaginateComponent
        }
    }
</script>

<style scoped>
.mvl {
    display: none !important;
}

@media (max-width: 767px) {
    .mobile-layout {
        display: block;
    }
    
    .mobile-row {
        display: flex;
        align-items: flex-start;
        padding: 0.5rem 0;
        border-bottom: 1px solid #f0f0f0;
        flex-wrap: wrap;
    }
    
    .mobile-row:last-child {
        border-bottom: none;
    }
    
    .mobile-label {
        font-weight: bold;
        font-size: 0.8rem;
        color: #495057;
        background: #e9ecef;
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        margin-right: 0.5rem;
        min-width: 120px;
        display: inline-block;
    }
    
    .mobile-value {
        font-size: 0.875rem;
        line-height: 1.4;
        flex: 1;
        word-break: break-word;
        padding: 0.25rem 0;
    }
    
    .concepto-row {
        background: #f8f9fa;
        padding: 0.75rem !important;
        border-radius: 6px;
        margin-top: 0.5rem;
        font-style: italic;
        color: #6c757d;
    }
    
    .text-break {
        word-break: break-all;
    }
    
    .mobile-buttons {
        margin-top: 1rem;
    }
    
    .mobile-buttons .btn {
        width: 100%;
        margin-right: 0 !important;
        margin-bottom: 0.5rem;
    }
    
    .btn-group.dropleft {
        width: 100%;
    }
    
    .btn-group.dropleft .dropdown-toggle {
        width: 100%;
    }
    
    .btn_rgt {
        margin-right: 0px !important;
    }
    
    .mvl_mrgn {
        margin-top: 12px !important;
    }
    
    .col-2, .col-4 {
        -ms-flex: 0 0 100% !important;
        flex: 0 0 100% !important;
        max-width: 100% !important;
    }
}

@media (min-width: 768px) {
    .mobile-layout {
        display: none !important;
    }
    
    .d-none.d-md-block {
        display: block !important;
    }
}
</style>